import WebGalleryUpsellBannerPFContent from './WebGalleryUpsellBannerPFContent';

export default WebGalleryUpsellBannerPFContent;
